<template>
  <div>
    <div class="mb-1">
      <b-link :to="{ name: 'orders-index' }">
        <feather-icon icon="ArrowLeftIcon" />
        <span class="align-middle">Back to List</span>
      </b-link>
    </div>
    <h3>Order Detail</h3>
    <b-card>
      <b-card-header>
        <u><h5>Customer Information</h5></u>
      </b-card-header>

      <b-row>
        <b-col>
          <b-form-group>
            Customer First Name:
            <strong>{{ detailOrder.firstName }}</strong>
          </b-form-group>
          <b-form-group>
            Customer Last Name:
            <strong>{{ detailOrder.lastName }} </strong>
          </b-form-group>
          <b-form-group>
            Customer Phone:
            <strong>{{ detailOrder.phone }} </strong>
          </b-form-group>
          <b-form-group>
            Customer Email:
            <strong>{{ detailOrder.email }} </strong>
          </b-form-group>
        </b-col></b-row
      ></b-card
    >
    <b-card>
      <b-card-header>
        <u><h5>Order Information</h5></u>
      </b-card-header>

      <b-row>
        <b-col>
          <b-form-group>
            <strong>Custom Order Code: </strong>
            <span>{{ detailOrder.customOrderCode }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Order Code</strong>:
            <span>{{ detailOrder.orderId }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Order Date: </strong>
            <span>{{ detailOrder.orderDateString }}</span>
          </b-form-group>
          <b-form-group>
            <strong> Expire Date: </strong>
            <span>{{ detailOrder.expiryDate }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Order Payment Option: </strong>
            <span>{{ detailOrder.paymentOptionName }}</span>
          </b-form-group>

          <b-form-group v-if="detailOrder.orderType === 0">
            <strong>Order Created By: </strong>
            <span>{{ detailOrder.orderHistories[0].actionTakenBy }}</span>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <strong>Currency: </strong>
            <span>{{ detailOrder.currency }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Amount: </strong>
            <span>{{ detailOrder.amount }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Payment Status: </strong>
            <!-- <span>{{ detailOrder.paymentStatusDescription }}</span> -->
            <span>
              <b-badge
                v-if="detailOrder.paymentStatus === 2"
                pill
                variant="success"
                class="text-light"
              >
                Approved
              </b-badge>
              <b-badge
                v-else-if="detailOrder.paymentStatus === 3"
                pill
                variant="danger"
                class="text-light"
              >
                Canceled
              </b-badge>
              <b-badge
                v-else-if="detailOrder.paymentStatus === 1"
                pill
                variant="warning"
                class="text-light"
              >
                Pending
              </b-badge>
            </span>
          </b-form-group>
          <b-form-group>
            <strong>Order Type: </strong>
            <span>{{ detailOrder.orderTypeDescription }}</span>
          </b-form-group>
          <b-form-group>
            <strong>City: </strong>
            <span>{{ detailOrder.city }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Country: </strong>
            <span>{{ detailOrder.country }}</span>
          </b-form-group>

          <b-form-group>
            <strong>Merchant Name: </strong>
            <span>{{ detailOrder.merchantName }}</span>
          </b-form-group>
        </b-col>
      </b-row></b-card
    >
    <b-card>
      <b-card-header>
        <u><h5>Payment Detail</h5></u>
      </b-card-header>

      <b-row>
        <b-col>
          <b-form-group>
            <strong>Paid Date: </strong>
            <span>{{ detailOrder.paidDateString }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Paid Payment Option: </strong>
            <span>{{ detailOrder.paidPaymentOption }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Vendor Txn RefNumber: </strong>
            <span>{{ detailOrder.vendorTxnRefNumber }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Paid Account: </strong>
            <span>{{
              detailOrder.paidAccountNumber
                ? detailOrder.paidAccountNumber.replace(
                    /(?<=^\d)\d+(?=\d{4}$)/,
                    "****",
                  )
                : ""
            }}</span>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            v-if="detailOrder.paymentStatusDescription == 'Approved'"
          >
            <strong>Approved by: </strong>
            <span
              v-for="(item, index) in detailOrder.orderHistories"
              :key="index"
            >
              {{
                item.actionTakenDescription === "Order Approved"
                  ? item.actionTakenBy
                  : null
              }}
            </span>
          </b-form-group>
          <b-form-group>
            <strong>Payment Method: </strong>
            <span>{{ detailOrder.paymentMethod }}</span>
          </b-form-group>
          <b-form-group>
            <strong>Payment Description: </strong>
            <span>{{ detailOrder.transactionDescription }}</span>
          </b-form-group>

          <b-form-group>
            <strong>Merchant Service No.: </strong>
            <span>{{ detailOrder.merchantServiceNumber }}</span>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-card-header>
        <u><h5>System Notification Response</h5></u>
      </b-card-header>

      <b-row>
        <b-col>
          <b-form-group>
            <strong>Is Notified: </strong>
            <span>{{ detailOrder.isNotify }}</span>
          </b-form-group>

          <b-form-group>
            <strong>Confirmation Attempt Count: </strong>
            <span>{{ detailOrder.confirmAttemptCount }}</span>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <strong> Notify Remark: </strong>
            <span>{{ detailOrder.notifyRemark }}</span>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-overlay :show="isLoading" no-wrap rounded="sm" />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BCard,
  BCardBody,
  BCardHeader,
  BOverlay,
  BLink,
  BBadge,
} from "bootstrap-vue";

import axios from "@axios";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BCard,
    BCardBody,
    BCardHeader,
    BOverlay,
    BLink,
    BBadge,
  },
  data() {
    return {
      isLoading: false,
      detailOrder: {
        id: 0,
        firstName: "",
        lastName: "",
        email: "",
        paymentOptionName: "",
        paymentOptionsId: 0,
        phone: "",
        amount: 0,
        currency: "",
        paymentStatus: 0,
        paidDateString: "",
        city: "",
        country: "",
        channel: "",
        orderId: "",
        customOrderCode: "",
        paymentStatusDescription: "",
        traceNumbers: "",
        expiryDate: "",
        traceNumber: "",
        isNotify: false,
        notifyRemark: "",
        paymentOption: "",
        merchantName: "",
        vendorTxnRefNumber: "",
        statusDescription: null,
        orderDateString: "",
        refundWorkflowAttemptCount: 0,
        refundWorkflowCurrentLevel: 0,
        refundAccountNumber: "",
        refundToSeparateAccount: false,
        refundRequestedDate: "",
        refundRequestedAmount: 0,
        orderHistories: null,
        orderRefundWorkFlowHistories: null,
        status: 1,
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Order-Detail");
      axios
        .get(`/Order/api/V1.0/Orders/GetOrderById?id=${this.$route.params.id}`)
        .then((res) => {
          this.isLoading = false;
          // console.log(res)
          this.detailOrder = res;
        })
        .catch((res) => {
          console.log(res);
          this.isLoading = false;
        });
    },
  },
};
</script>
<style scoped></style>
